module.exports = __webpack_public_path__ + "static/media/agendamientos.e307fac5.svg";